import type { ReactNode } from 'react';

export const symbol_x_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m479-459 109 179q6 10 15.5 11.5T621-272q8-5 11-13.5t-4-19.5L509-490l110-168q6-9 3-17t-10-13q-7-5-15.5-4T582-681L481-519 380-681q-6-10-14.5-11t-16.5 4q-8 5-11 14t4 19l109 166-121 187q-6 9-3 17t10 13q7 5 16 4t15-11l111-180ZM324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM480-140q141 0 240.5-99T820-480q0-141-99.5-240.5T480-820q-142 0-241 99.5T140-480q0 142 99 241t241 99Zm0-340Z"
		/>
	</svg>
);
